import React from 'react';
import { Upload } from 'antd';

const { Dragger } = Upload;


export default function CustomDragDropUpload({ children, ...props }) {
	return (
		<>
			<Dragger {...props}>{children}</Dragger>
		</>
	);
}